var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 21v-6.008c0-1.728.33-3.525.991-5.39A22.943 22.943 0 013.755 4.27C4.937 2.582 6.26 1.158 7.721 0l5.047 3.21A31.718 31.718 0 009.794 8.69c-.781 1.885-1.162 3.966-1.142 6.244V21H0zm15.232 0v-6.008c0-1.728.33-3.525.991-5.39a22.942 22.942 0 012.764-5.331C20.17 2.582 21.491 1.158 22.953 0L28 3.21a31.71 31.71 0 00-2.974 5.479c-.781 1.885-1.162 3.966-1.142 6.244V21h-8.652z","fill":"#BA6FD7"}));
}

Quote.defaultProps = {"width":"28","height":"21","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
